import changeDateFormat from './changeDateFormat';
import truncate from './truncate';
import calculateNight from './calculateNight';
import getDateForRange from './getDateForRange';
import getWeekDayFromDate from './getWeekDayFromDate';
import getDateForBooking from './getDateForBooking';
import getDateForTitle from './getDateForTitle';
import getWeekDay from './getWeekDay';
import getYear from './getYear';
import getMonthDays from './getMonthDays';

export default {
  install(Vue) {
    Vue.filter('changeDateFormat', changeDateFormat);
    Vue.filter('truncate', truncate);
    Vue.filter('calculateNight', calculateNight);
    Vue.filter('getDateForRange', getDateForRange);
    // Vue.filter('getWeekDayFromDate', getWeekDayFromDate);
    // Vue.filter('getDateForBooking', getDateForBooking);
    // Vue.filter('getDateForTitle', getDateForTitle);
    // Vue.filter('getWeekDay', getWeekDay);
    // Vue.filter('getYear', getYear);
    // Vue.filter('getMonthDays', getMonthDays);
  }
}



// WEBPACK FOOTER //
// ./src/app/filters/index.js